import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/portal/v1`;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("pm_token")) {
      localStorage.removeItem("pm_token");
      localStorage.removeItem("pm_user");
      if (!window.location.pathname.endsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Something went wrong";
}
